"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _SetUserPreferenceModel = _interopRequireDefault(require("./SetUserPreferenceModel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The SetUserPreferencesModel model module.
 * @module model/SetUserPreferencesModel
 * @version 1.1.3-alpha.1
 */
class SetUserPreferencesModel {
  /**
   * Constructs a new <code>SetUserPreferencesModel</code>.
   * @alias module:model/SetUserPreferencesModel
   */
  constructor() {
    SetUserPreferencesModel.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>SetUserPreferencesModel</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SetUserPreferencesModel} obj Optional instance to populate.
   * @return {module:model/SetUserPreferencesModel} The populated <code>SetUserPreferencesModel</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SetUserPreferencesModel();
      if (data.hasOwnProperty('preferences')) {
        obj['preferences'] = _ApiClient.default.convertToType(data['preferences'], [_SetUserPreferenceModel.default]);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>SetUserPreferencesModel</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SetUserPreferencesModel</code>.
   */
  static validateJSON(data) {
    if (data['preferences']) {
      // data not null
      // ensure the json data is an array
      if (!Array.isArray(data['preferences'])) {
        throw new Error("Expected the field `preferences` to be an array in the JSON data but got " + data['preferences']);
      }
      // validate the optional field `preferences` (array)
      for (const item of data['preferences']) {
        _SetUserPreferenceModel.default.validateJSON(item);
      }
      ;
    }
    return true;
  }
}

/**
 * @member {Array.<module:model/SetUserPreferenceModel>} preferences
 */
SetUserPreferencesModel.prototype['preferences'] = undefined;
var _default = exports.default = SetUserPreferencesModel;